'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _CaseUpdateModule = require('./CaseUpdates/CaseUpdateModule');

var _CaseUpdateModule2 = _interopRequireDefault(_CaseUpdateModule);

var _CaseInfo = require('./CaseInfo');

var _CaseInfo2 = _interopRequireDefault(_CaseInfo);

var _ServicingInfo = require('./ServicingInfo');

var _ServicingInfo2 = _interopRequireDefault(_ServicingInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var TabDetails = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(TabDetails, _Component);

  function TabDetails() {
    _classCallCheck(this, TabDetails);

    return _possibleConstructorReturn(this, (TabDetails.__proto__ || Object.getPrototypeOf(TabDetails)).apply(this, arguments));
  }

  _createClass(TabDetails, [{
    key: 'render',
    value: function render() {
      var _case = this.props._case;


      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true, className: 'case-detail-tab tab-details' },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            null,
            _react2.default.createElement(_CaseUpdateModule2.default, { _case: _case }),
            _react2.default.createElement(_ServicingInfo2.default, { _case: _case }),
            _react2.default.createElement(_CaseInfo2.default, { _case: _case })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TabDetails;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class;

var _default = TabDetails;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabDetails, 'TabDetails', '/app/src/components/page-case/main-details/TabDetails.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/TabDetails.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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